<template>
  <div>
    <b-modal
      v-model="open"
      :title="`Detalhes da tarefa`"
      centered
      hide-footer
      hide-header-close
      @hidden="closeEditModal"
    >
      <b-card
        :title="`${
          item.task_title
            ? item.task_title.task_title.toUpperCase()
            : bypassWatch
            ? item.task_name
            : item && item.title
            ? item.title
            : 'Tipo não associado'
        }`"
        border-variant="warning"
        footer-tag="footer"
      >
        <b-card-sub-title class="mb-1">
          <span class="text-dark">
            {{ `Responsável: ${item.username}` }}
          </span>
        </b-card-sub-title>
        <b-card-text>
          <p v-if="!bypassWatch">
            Projeto: <b>{{ item.project_code }} - {{ item.project_name }}</b
            ><br />
          </p>
          <p v-else>
            Projeto: <b>{{ item.project }} </b><br />
          </p>
          Execução: <b>{{ item.start }} - {{ item.end }}</b
          ><br />
          Data: <b>{{ formatDate }}</b> <br />
          Prazo para execução:
          <b>{{ this.eventDuration(item.end, item.start) }}</b> <br />
          Prioridade: <b>{{ item.priority ? item.priority : 'Não definida' }}</b
          ><br />
          Status: <b>{{ item.status ? item.status : 'Não definido' }}</b
          ><br />
          Nível da Tarefa:
          <b>{{
            item.level
              ? item.level == 'tatic'
                ? 'TÁTICO'
                : item.level == 'estrategico'
                ? 'ESTRATÉGICO'
                : item.level == 'operacional'
                ? 'OPERACIONAL'
                : 'Desconhecido'
              : 'Não definido'
          }}</b
          ><br />
          Risco:
          <b>{{
            item.risk == 'baixa'
              ? 'Baixo'
              : item.risk == 'media'
              ? 'Médio Risco'
              : item.risk == 'alta'
              ? 'Alto Risco'
              : 'Não definido'
          }}</b
          ><br />
          Nivel de custo:
          <b>{{
            item.cost == 'baixa'
              ? 'Baixo'
              : item.cost == 'media'
              ? 'Médio Risco'
              : item.cost == 'alta'
              ? 'Alto Risco'
              : 'Não definido'
          }}</b
          ><br />

          <br /><br />
          <strong>Observação: {{ item.notes }}</strong
          ><br /><br />
          <div v-if="displayEstimatedTotal(item)">
            Custos estimados:
            <b>R$ {{ displayEstimatedTotal(item) }}</b
            ><br />

            <br />
          </div>

          <!-- REAIS (se existirem, substituem totalmente os estimados) -->
          <div v-if="displayRealTotal(item)">
            Custos reais:
            <b>R$ {{ displayRealTotal(item) }} </b><br />

            <br />
          </div>
          <br />
          <b>
            ETAPA NO PROJETO:
            {{
              item && item.project_stage && item.project_stage.stage_name
                ? item.project_stage.stage_name
                : item && item.stage && item.stage.stage_name
                ? item.stage.stage_name
                : ''
            }}</b
          >
        </b-card-text>
        <template #footer>
          <b-link href="#" class="card-link" @click="openEditModal"
            >Editar tarefa</b-link
          >
          <b-link href="#" class="card-link" @click="closeEditModal"
            >Voltar</b-link
          >
        </template>
      </b-card>
    </b-modal>

    <b-modal
      ref="editModal"
      :title="`Detalhes da tarefa`"
      centered
      no-close-on-backdrop
      hide-footer
      hide-header-close
      size="lg"
    >
      <!-- Formulario -->
      <validation-observer ref="FormSaveTask">
        <hr class="invoice-spacing mb-3" />
        <b-form>
          <b-row class="text-left mt-4">
            <b-col cols="12" md="6">
              <!-- PROJETOS -->
              <b-form-group class="mb-2">
                <label for="category" class="font-weight-bold text-primary"
                  >Projetos :</label
                ><br />
                <label>
                  <div
                    @click="handleShowArquived()"
                    :style="{
                      color: 'blue',
                      padding: '5px 0',
                      cursor: 'pointer',
                    }"
                  >
                    {{
                      showArquivded
                        ? 'Ocultar arquivados'
                        : 'Mostrar arquivados'
                    }}
                  </div></label
                >
                <validation-provider
                  #default="{ errors }"
                  :custom-messages="{ required: 'Este campo é obrigatório' }"
                  rules="required"
                >
                  <v-select
                    v-model="item.project_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    placeholder="Selecione..."
                    :options="projects"
                    @input="getProjectStages"
                    :reduce="(option) => option.id"
                    label="name"
                    class="mb-2"
                  >
                    <div slot="no-options">
                      Desculpe, não existe projeto cadastrado!
                    </div>
                    <template
                      #list-header
                      v-if="
                        (userAccesses && userAccesses.is_admin) ||
                        (userAccesses && userAccesses.is_manager)
                      "
                    >
                      <li
                        class="add-new-header d-flex align-items-center my-50 cursor-pointer"
                        @click="$router.push({ name: 'novo-projeto' })"
                      >
                        <feather-icon icon="PlusIcon" size="16" />
                        <span class="align-middle ml-25">Add Novo Projeto</span>
                      </li>
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group class="mb-2" v-if="item.project_id">
                <label
                  for="category"
                  style="margin-bottom: 30px"
                  class="font-weight-bold text-primary"
                  >Etapa do projeto :</label
                ><br />
                <validation-provider
                  #default="{ errors }"
                  :custom-messages="{ required: 'Este campo é obrigatório' }"
                  rules="required"
                >
                  <b-form-select
                    v-model="item.project_stage_id"
                    :options="project_stages"
                    value-field="id"
                    text-field="stage_name"
                    placeholder="Selecione uma etapa"
                  ></b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <!-- TITULO -->
              <b-form-group
                class="mb-2"
                v-if="
                  currentWorkspace &&
                  currentWorkspace.complete_workspace == false
                "
              >
                <label class="font-weight-bold text-primary"
                  >Tipo de tarefa:</label
                >
                <b-form-input v-model="item.title"></b-form-input>
              </b-form-group>

              <div class="w-100 mb-2" v-else>
                <label class="font-weight-bold text-primary"
                  >Tipo de tarefa:</label
                >
                <!-- Garante que o v-select ocupe a largura total -->
                <validation-provider
                  #default="{ errors }"
                  :custom-messages="{ required: 'Este campo é obrigatório' }"
                  rules="required"
                >
                  <v-select
                    v-model="item.task_title_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    placeholder="Selecione"
                    :options="task_title_arr"
                    :reduce="(option) => option.id"
                    label="name"
                  >
                    <div slot="no-options">
                      Desculpe, mas o projeto não tem tipo de tarefa!
                    </div>
                    <template #list-header>
                      <li
                        class="add-new-header d-flex align-items-center my-50 cursor-pointer"
                        @click="$router.push({ name: 'novo-titulo-tarefa' })"
                      >
                        <feather-icon icon="PlusIcon" size="16" />
                        <span class="align-middle ml-25"
                          >Add Novo tipo de tarefa</span
                        >
                      </li>
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="4">
              <!-- DATA DE REFERÊNCIA -->
              <b-form-group class="mb-2" :disabled="item.isRepeatActive">
                <label for="referenceDate" class="font-weight-bold text-primary"
                  >Data :</label
                >
                <validation-provider
                  #default="{ errors }"
                  :custom-messages="{ required: 'Este campo é obrigatório' }"
                  rules="required"
                >
                  <b-form-input
                    id="referenceDate"
                    type="date"
                    v-model="item.date"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <!-- HORA DE INÍCIO -->
              <b-form-group class="mb-2">
                <label for="startTime" class="font-weight-bold text-primary"
                  >Hora de Início:</label
                >
                <validation-provider
                  #default="{ errors }"
                  :custom-messages="{ required: 'Este campo é obrigatório' }"
                  rules="required"
                >
                  <b-form-input
                    maxlength="5"
                    id="startTime"
                    type="time"
                    value="09:20"
                    v-model="item.start"
                    @input="item.start = formatHour($event)"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <!-- HORA DE FIM -->
              <b-form-group class="mb-2">
                <label for="endTime" class="font-weight-bold text-primary"
                  >Hora de Fim:</label
                >
                <validation-provider
                  #default="{ errors }"
                  :custom-messages="{ required: 'Este campo é obrigatório' }"
                  rules="required"
                >
                  <b-form-input
                    maxlength="5"
                    id="endTime"
                    type="time"
                    v-model="item.end"
                    @input="item.end = formatHour($event)"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <!-- Descricao -->
              <b-form-group class="mb-2">
                <label class="font-weight-bold text-primary">Descriçao:</label>
                <b-form-textarea v-model="item.notes"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="4">
              <label for="" class="font-weight-bold text-primary"
                >Prioridade da tarefa:</label
              >
              <b-form-select
                id=""
                v-model="item.priority"
                :options="priorityOptions"
                value-field="value"
                text-field="name"
                placeholder="Selecione um projeto"
                class="mb-2"
                :disabled="userAccesses && userAccesses.is_common"
              ></b-form-select>
            </b-col>
            <b-col cols="12" md="4">
              <label for="" class="font-weight-bold text-primary"
                >Custo da tarefa:

                <feather-icon
                  v-b-tooltip.hover.lefttop.v-primary.html
                  :title="`<div style='text-align: left;'><b>NIVEL ESTRATÉGICO:</b> Direção Executiva, Conselho Adm, Diretores, VP. <br><br>
                  <b>NÍVEL TATICO:</b> Gerentes de departamentos, Coordenadores de projeto, Equipe de planejamento.<br><br>
                  <b>NÍVEL OPERACIONAL:</b> Equipes de trabalho, Supervisores, Lideres de equipe, Colaboradores.</div>`"
                  icon="InfoIcon"
                  size="15"
                  style="cursor: pointer"
                />
              </label>
              <b-form-select
                id=""
                v-model="item.cost"
                :options="costOptions"
                value-field="value"
                text-field="name"
                placeholder="Selecione um custo"
                class="mb-2"
                :disabled="userAccesses && userAccesses.is_common"
              ></b-form-select>
            </b-col>
            <b-col cols="12" md="4">
              <label for="" class="font-weight-bold text-primary"
                >Risco da tarefa:
                <feather-icon
                  v-b-tooltip.hover.lefttop.v-primary.html
                  :title="`<div style='text-align: left;'><b>NIVEL ESTRATÉGICO:</b> Direção Executiva, Conselho Adm, Diretores, VP. <br><br>
                  <b>NÍVEL TATICO:</b> Gerentes de departamentos, Coordenadores de projeto, Equipe de planejamento.<br><br>
                  <b>NÍVEL OPERACIONAL:</b> Equipes de trabalho, Supervisores, Lideres de equipe, Colaboradores.</div>`"
                  icon="InfoIcon"
                  size="15"
                  style="cursor: pointer"
                />
              </label>
              <b-form-select
                id=""
                v-model="item.risk"
                :options="riskOptions"
                value-field="value"
                text-field="name"
                placeholder="Selecione um custo"
                class="mb-2"
                :disabled="userAccesses && userAccesses.is_common"
              ></b-form-select>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="6">
              <label for="" class="font-weight-bold text-primary"
                >Estado da tarefa:</label
              >
              <b-form-select
                id=""
                v-model="item.status"
                :options="statusOptions"
                value-field="value"
                text-field="name"
                placeholder="Selecione um projeto"
                class="mb-2"
              ></b-form-select
            ></b-col>
            <b-col cols="12" md="6"
              ><label for="" class="font-weight-bold text-primary"
                >Nível de tarefa:
                <feather-icon
                  v-b-tooltip.hover.lefttop.v-primary.html
                  :title="`<div style='text-align: left;'><b>NIVEL ESTRATÉGICO:</b> Direção Executiva, Conselho Adm, Diretores, VP. <br><br>
                  <b>NÍVEL TATICO:</b> Gerentes de departamentos, Coordenadores de projeto, Equipe de planejamento.<br><br>
                  <b>NÍVEL OPERACIONAL:</b> Equipes de trabalho, Supervisores, Lideres de equipe, Colaboradores.</div>`"
                  icon="InfoIcon"
                  size="15"
                  style="cursor: pointer"
              /></label>
              <b-form-select
                id=""
                v-model="item.level"
                :options="levelOptions"
                value-field="value"
                text-field="name"
                placeholder="Selecione um nível"
                :disabled="userAccesses && userAccesses.is_common"
                class="mb-2"
              ></b-form-select
            ></b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="6">
              <label for="" class="font-weight-bold text-primary"
                >Retrabalho:</label
              >
              <b-form-select
                id=""
                v-model="item.rework"
                :options="reworkOptions"
                value-field="value"
                text-field="name"
                placeholder="Selecione um nível"
                class="mb-2"
              ></b-form-select>
            </b-col>

            <b-col cols="12" md="6">
              <label for="" class="font-weight-bold text-primary"
                >Trabalho remoto:</label
              >
              <b-form-select
                id=""
                v-model="item.remote"
                :options="remoteOptions"
                value-field="value"
                text-field="name"
                placeholder="Selecione um nível"
                class="mb-2"
              ></b-form-select>
            </b-col>
          </b-row>

          <hr class="invoice-spacing" />
        </b-form>
      </validation-observer>

      <!-- Botoes -->
      <b-row class="justify-content-around p-2">
        <b-col cols="12" md="4">
          <b-button
            variant="warning"
            class="mr-2 w-100 mb-2"
            @click="closeEditModal"
            >Voltar
          </b-button>
        </b-col>
        <b-col cols="12" md="4">
          <b-button
            variant="danger"
            @click="confirmDeleteModal"
            class="mr-1 w-100 mb-2"
            >Deletar
          </b-button>
        </b-col>
        <b-col cols="12" md="4">
          <b-button @click="saveTask" variant="primary" class="mr-1 w-100"
            >Salvar
          </b-button>
        </b-col>
      </b-row>

      <b-modal ref="modal-confirm" hide-footer centered title="Um momento">
        <p class="my-4">Deseja mesmo excluir a tarefa?</p>
        <hr />
        <b-row class="justify-content-around d-flex">
          <b-button variant="danger" class="mr-2" @click="deleteTask"
            >Sim
          </b-button>
          <b-button variant="warning" class="mr-2" @click="hideDeleteModal"
            >Não
          </b-button>
        </b-row>
      </b-modal>
    </b-modal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import {
  BModal,
  BForm,
  BRow,
  BFormGroup,
  BFormSelect,
  BButton,
  BFormInput,
  BFormTextarea,
  BCard,
  BCardText,
  VBTooltip,
  BLink,
  BCol,
  BCardSubTitle,
} from 'bootstrap-vue';
import { differenceInMinutes, format, parseISO } from 'date-fns';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import Ripple from 'vue-ripple-directive';
import { required } from '@validations';

import moment from 'moment';

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  name: 'new-task',
  props: {
    _item: { type: Object, require: true },
    open: {
      type: Boolean,
      default: false,
    },
    costs_variables: { type: Object, require: false },
    bypassWatch: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BModal,
    BForm,
    BRow,
    BFormGroup,
    BFormSelect,
    BButton,
    ValidationObserver,
    ValidationProvider,
    BFormInput,
    BFormTextarea,
    BCard,
    BCardText,
    BLink,
    BCol,
    BCardSubTitle,
  },
  data() {
    return {
      required,
      showArquivded: false,
      workspace_name: '',
      priorityOptions: [
        { name: 'Baixa', value: 'Baixa' },
        { name: 'Média', value: 'Media' },
        { name: 'Alta', value: 'Alta' },
      ],
      statusOptions: [
        { name: 'PREVISTA', value: 'PREVISTA' },
        { name: 'EM EXECUÇÃO', value: 'EM EXECUÇÃO' },
        { name: 'EM PAUSA', value: 'EM PAUSA' },
        { name: 'CONCLUÍDA', value: 'CONCLUÍDA' },
        { name: 'CANCELADA', value: 'CANCELADA' },
      ],
      levelOptions: [
        { name: 'ESTRATÉGICO', value: 'estrategico' },
        { name: 'TÁTICO', value: 'tatic' },
        { name: 'OPERACIONAL', value: 'operacional' },
      ],
      costOptions: [
        { name: 'Baixo Custo', value: 'baixa' },
        { name: 'Medio Custo', value: 'media' },
        { name: 'Alto Custo', value: 'alta' },
      ],
      riskOptions: [
        { name: 'Baixo Risco', value: 'baixa' },
        { name: 'Medio Risco', value: 'media' },
        { name: 'Alto Risco', value: 'alta' },
      ],
      reworkOptions: [
        { name: 'Sim', value: true },
        { name: 'Não', value: false },
      ],
      remoteOptions: [
        { name: 'Sim', value: true },
        { name: 'Não', value: false },
      ],
      item: {
        project_id: null,
        title: '',
        date: null,
        start: '',
        end: '',
        notes: '',
        real_direct_cost: '100',
        indirect_cost: '100',
        real_indirect_cost: '100',
        direct_cost: null,
        priority: '',
        status: '',
        level: '',
        cost: '',
        risk: '',
        rework: false,
        remote: false,
      },
      member_id: '',
      projects: [],
      project_stages: [],
      task_title_arr: [],
      loading: false,
      originalDate: '',
    };
  },

  created() {
    this.getMemberId();
    this.loadProjects();
    this.workspace_name = this.$store.getters.currentWorkspace.workspace_title;
  },

  computed: {
    formatDate() {
      return this.open ? format(parseISO(this.item.date), 'dd/MM/yyyy') : '';
    },
    currentWorkspace() {
      return this.$store.getters.currentWorkspace;
    },
    userAccesses() {
      return this.$store &&
        this.$store.getters &&
        this.$store.getters.userAccesses
        ? this.$store.getters.userAccesses
        : null;
    },
  },

  watch: {
    _item: {
      handler(newPreTime) {
        if (this.bypassWatch) {
          this.item = {
            ...newPreTime,
            start: newPreTime.start.slice(0, 5),
            end: newPreTime.end.slice(0, 5),
            date: this.dateFormatter(newPreTime.date, 'yyyy-MM-dd'),
          };
        } else {
          this.item = {
            ...newPreTime,
            start: newPreTime.startTime.slice(0, 5),
            end: newPreTime.endTime.slice(0, 5),
            date: this.dateFormatter(newPreTime.date, 'yyyy-MM-dd'),
          };
          if (this.item.project_id) {
            this.getProjectStages();
          }
        }
        if (
          this.currentWorkspace &&
          this.currentWorkspace.complete_workspace == true
        ) {
          this.getAllTaskTitles();
        }
      },
      deep: true,
    },
  },

  methods: {
    displayEstimatedTotal(item) {
      const hasReal = item.real_direct_cost > 0 && item.real_indirect_cost > 0;

      const hasEstimated = item.direct_cost > 0 && item.indirect_cost > 0;

      console.log('hasReal', hasReal);
      console.log('hasEstimated', hasEstimated);

      if (hasEstimated && !hasReal) {
        return this.numberToMonetary(item.indirect_cost + item.direct_cost);
      }

      return null; // não exibe
    },

    displayRealTotal(item) {
      const hasReal = item.real_direct_cost > 0 && item.real_indirect_cost > 0;

      if (hasReal) {
        return this.numberToMonetary(
          item.real_direct_cost + item.real_indirect_cost,
        );
      }

      return null; // não exibe
    },
    async getAllTaskTitles() {
      this.task_title_arr = [];

      this.$store
        .dispatch('getAllTaskTitles', {
          workspace_id: this.currentWorkspace.id,
          page: 1,
          perPage: 1000,
          inactive: false,
        })
        .then((resp) => {
          resp.data.map((item) => {
            let obj = {
              id: item.id,
              name: item.task_title.toUpperCase(),
            };
            this.task_title_arr.push(obj);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openEditModal() {
      this.$nextTick(() => {
        this.$refs.editModal.show();
        this.getProjectStages();
      });
      this.originalDate = this.item.date;
    },
    closeEditModal(val) {
      console.log('emitiu');
      this.$refs.editModal.hide();
      this.$emit('closeModal', val);
    },
    confirmDeleteModal() {
      this.$refs['modal-confirm'].show();
    },
    hideDeleteModal() {
      this.$refs['modal-confirm'].hide();
    },
    async getMemberId() {
      this.$store
        .dispatch('getUserMember', {
          id: this.$store.getters.user.id,
          workspace_id: this.$store.getters.currentWorkspace.id,
        })
        .then((resp) => {
          this.member_id = resp[0].member_id;

          let wage =
            resp && resp[0] && resp[0].member && resp[0].member.cost_per_month
              ? resp[0].member.cost_per_month
              : 0;
          let unproductively =
            resp && resp[0] && resp[0].member && resp[0].member.unproductively
              ? resp[0].member.unproductively
              : 0;
          const wageSafe = Number(wage) || 0;
          const unproductivelySafe = Number(unproductively) || 0;
          const hourPerMonthSafe = Number(resp[0]?.member?.hour_per_month) || 0;

          console.log('wageSafe', wageSafe);
          console.log('unproductivelySafe', unproductivelySafe);
          console.log('hourPerMonthSafe', hourPerMonthSafe);

          this.direct_cost =
            wageSafe && hourPerMonthSafe
              ? Math.floor(
                  (wageSafe * (100 - unproductivelySafe)) /
                    hourPerMonthSafe /
                    100,
                )
              : 0;

          console.log(' this.item.direct_cost 1111', this.direct_cost);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async saveTask() {
      const prevent = this.$store.getters.currentWorkspace?.prevent_create_task;
      const taskDate = moment(this.item.date).startOf('day');
      const today = moment().startOf('day');

      if (prevent) {
        const minDate = moment(today).subtract(prevent, 'days');
        const maxDate = moment(today).add(prevent, 'days');
        const dateChanged =
          this.originalDate && this.item.date !== this.originalDate;

        if (taskDate.isBefore(minDate) || taskDate.isAfter(maxDate)) {
          if (!this.originalDate || dateChanged) {
            this.$bvToast.toast(
              `Você só pode criar tarefas entre ${minDate.format(
                'DD/MM/YYYY',
              )} e ${maxDate.format('DD/MM/YYYY')}.`,
              {
                title: 'Ação não permitida',
                variant: 'danger',
                solid: true,
              },
            );
            return;
          }
        }
      }

      this.$refs.FormSaveTask.validate().then((success) => {
        if (success) {
          const startTime = this.item.start.split(':');
          const endTime = this.item.end.split(':');

          const startDate = new Date();
          startDate.setHours(startTime[0], startTime[1]);

          const endDate = new Date();
          endDate.setHours(endTime[0], endTime[1]);

          if (endDate <= startDate) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Hora de fim deve ser maior que a hora de início',
                icon: 'ErrorIcon',
                variant: 'danger',
              },
            });
            return;
          }

          const redate = moment(this.item.date).utcOffset(-6, true);

          this.item.start = this.transformInCompleteData(this.item.start);
          this.item.end = this.transformInCompleteData(this.item.end);

          const duration = (endDate - startDate) / (1000 * 60 * 60);
          const proportionalDirectCost = parseInt(this.direct_cost * duration);

          console.log(' this.item.direct_cost ', this.direct_cost);

          console.log(
            'this.costs_variables.average_office_cost',
            this.costs_variables.average_office_cost,
          );
          console.log(
            'this.costs_variables.hour_per_month',
            this.costs_variables.hour_per_month,
          );
          console.log('duration', duration);

          this.$store
            .dispatch('updateMyTask', {
              id: this.item && this.item.id ? this.item.id : this.item.task_id,
              project_id: this.item.project_id,
              member_id: this.item.member_id,
              project_stage_id: this.item.project_stage_id,
              title: this.item.title,
              notes: this.item.notes,
              date: redate,
              start: this.item.start,
              priority: this.item.priority,
              status: this.item.status,
              risk: this.item.risk,
              rework: this.item.rework,
              remote: this.item.remote,
              cost: this.item.cost,
              direct_cost: proportionalDirectCost,
              indirect_cost: parseInt(
                (this.costs_variables.average_office_cost /
                  this.costs_variables.hour_per_month) *
                  duration,
              ),
              task_title_id: this.item.task_title_id
                ? this.item.task_title_id
                : null,
              end: this.item.end,
              updated_at: new Date(),
              workspace_id: this.$store.getters.currentWorkspace.id,
              level: this.item.level,
            })
            .then((resp) => {
              if (resp) {
                if (this.item.status === 'CONCLUÍDA') {
                  // Acessa o socket criado no App.vue via this.$root ou via import direto
                  const socket = this.$root.$socket;
                  if (socket && socket.connected) {
                    socket.emit('task:completed', {
                      task_id: this.item.id || this.item.task_id,
                      task_title:
                        this.item.task_title?.task_title ||
                        this.item.title ||
                        '',
                      username: this.$store.getters.user?.name || '',
                      project_name: this.item.project_name || '',
                    });
                  }
                }
                if (this.bypassWatch == true) {
                  console.log('aaaaaaaaaaaaaaaaaaaaaaa');
                  this.$emit('updateTaskList');
                }
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Tarefa atualizada com sucesso',
                    icon: 'SuccessIcon',
                    variant: 'success',
                  },
                });
                this.closeEditModal(true);
              }
            })
            .catch((err) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Erro',
                  icon: 'ErrorIcon',
                  variant: 'danger',
                  text: err.response?.data?.message,
                },
              });
              console.log(err);
            });
        }
      });
    },

    async deleteTask() {
      this.$store
        .dispatch('deleteTask', {
          id: this.item.id,
        })
        .then((resp) => {
          if (resp) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Tarefa excluida com sucesso',
                icon: 'SuccessIcon',
                variant: 'success',
              },
            });
            this.closeEditModal();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async loadProjects() {
      let body = {
        id: this.$route.params.id,
        workspace_id: this.$store.getters.currentWorkspace.id,
        perPage: 1000,
      };
      this.$store
        .dispatch('_getProjects', this.formatQueryParams(body))
        .then((resp) => {
          resp.data.map((e) => {
            if (this.showArquivded) {
              this.projects.push({
                id: e.id,
                name: `${e.project_code} - ${e.project_name} ${
                  e.is_archived ? '(Arquivado)' : ''
                }`,
              });
            } else {
              if (e.is_archived) {
                return null;
              } else {
                this.projects.push({
                  id: e.id,
                  name: `${e.project_code} - ${e.project_name} ${
                    e.is_archived ? '(Arquivado)' : ''
                  }`,
                });
              }
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getProjectStages() {
      this.project_stages = [];
      try {
        await this.$store
          .dispatch('getProjectStages', {
            project_id: this.item.project_id,
            workspace_id: this.$store.getters.currentWorkspace.id,
          })
          .then((resp) => {
            this.project_stages = resp.map((item) => ({
              id: item.id,
              stage_name: item && item.stage_name ? item.stage_name : '',
            }));
          });
      } catch (error) {
        console.error('Erro ao carregar projetos', error);
      }
    },

    transformNumberInHour(numero) {
      if (numero >= 0 && numero <= 23) {
        const horasFormatadas = numero < 10 ? `0${numero}` : `${numero}`;
        return `${horasFormatadas}:00`;
      } else {
        return 'Número inválido. Por favor, insira um número de 0 a 23.';
      }
    },

    transformInCompleteData(hour) {
      const dataAtual = new Date(this.item.date);
      dataAtual.setDate(dataAtual.getDate() + 1);
      dataAtual.setHours(hour.split(':')[0]);
      dataAtual.setMinutes(hour.split(':')[1]);

      return this.dateFormatter(dataAtual, 'yyyy-MM-dd HH:mm:ss');
    },

    formatHour(hour) {
      return hour;
    },
    onlyHours(dataString) {
      const data = new Date(dataString);
      data.setHours(data.getHours());

      const horas = data.getHours();
      const minutos = data.getMinutes();

      const horasFormatadas = horas < 10 ? '0' + horas : horas;
      const minutosFormatados = minutos < 10 ? '0' + minutos : minutos;

      return `${horasFormatadas}:${minutosFormatados}`;
    },

    eventDuration(endTime, startTime) {
      const end = new Date(`01 january 2024 ${endTime} GMT-3`);
      const start = new Date(`01 january 2024 ${startTime} GMT-3`);

      const totalMinutes = differenceInMinutes(end, start);

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
        2,
        '0',
      )}`;
    },
    handleShowArquived() {
      this.showArquivded = !this.showArquivded;
      this.projects = [];
      this.loadProjects();
    },
  },
};
</script>

<style>
.card-subtitle {
  color: #000 !important;
}
</style>
